import withAxios from './request';
import API_CONFIG from './apis';

export * from './agent';

export default withAxios(API_CONFIG);
